export default __webpack_public_path__ + "static/media/sound_of_water.a53758cc.png";